import { Link } from 'react-router-dom';
import PublicLayout, { SEOHead, CTASection } from '../../components/PublicLayout';
import { LANGUAGES } from '../../data/seo-data';
import IMAGES from '../../data/seo-images';

export default function LanguagesHubPage() {
  return (
    <PublicLayout>
      <SEOHead title="All Languages | 250+ Interpreter Languages | Interpreter Services" description="Find a professional interpreter in 200+ languages. Spanish interpreter, Mandarin interpreter, Arabic interpreter, French interpreter and more. Phone, video & on-site interpreting available 24/7 across the US, Canada, UK & Australia." canonical="https://interpreterservices.us/languages" />

      <section className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-white py-16">
        <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="text-4xl sm:text-5xl font-bold mb-4">Find a Language Interpreter — 200+ Languages</h1>
            <p className="text-lg text-blue-100 max-w-3xl">Need an interpreter? We provide qualified interpreters in over 200 languages and dialects. Select a language below to find your interpreter.</p>
          </div>
          <div className="hidden lg:block">
            <img src={IMAGES.globe[2].url} alt={IMAGES.globe[2].alt} className="rounded-2xl shadow-lg w-full object-cover h-56" loading="eager" data-testid="langhub-img-1" />
          </div>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-6 py-16">
        <img src={IMAGES.interpreting[0].url} alt={IMAGES.interpreting[0].alt} className="w-full rounded-xl mb-10 object-cover h-56 md:h-72" loading="lazy" data-testid="langhub-img-2" />
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {LANGUAGES.map(l => (
            <Link key={l.slug} to={`/${l.slug}-interpreter-services`} className="px-4 py-3 border rounded-lg text-sm hover:bg-blue-50 hover:border-blue-200 transition-colors font-medium" data-testid={`lang-link-${l.slug}`}>{l.name} Interpreter</Link>
          ))}
        </div>
        <p className="text-sm text-slate-500 mt-8 text-center">Don't see your language? Contact us — we support over 250 languages including rare and indigenous languages.</p>
        <img src={IMAGES.callCenter[1].url} alt={IMAGES.callCenter[1].alt} className="w-full rounded-xl mt-10 mb-4 object-cover h-48 md:h-64" loading="lazy" data-testid="langhub-img-3" />
        <img src={IMAGES.globe[0].url} alt={IMAGES.globe[0].alt} className="w-full rounded-xl mt-6 mb-4 object-cover h-48 md:h-64" loading="lazy" data-testid="langhub-img-4" />
      </div>

      <CTASection variant="secondary" />
    </PublicLayout>
  );
}
